(function () {
  function init(form) {
    if (!form || form.dataset.naokoClubInit === '1') return;
    form.dataset.naokoClubInit = '1';

    var consent = form.querySelector('[data-naoko-consent]');
    var submit = form.querySelector('[data-naoko-submit]');

    if (consent && submit) {
      var sync = function () { submit.disabled = !consent.checked; };
      consent.addEventListener('change', sync);
      sync();
    }
  }

  function boot() {
    document.querySelectorAll('.naoko-club-form').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
